import {
    madnes_get_pos_x,
    madnes_get_pos_y,
    madnes_get_scale_x, madnes_get_scale_y, madnes_get_visible,
    madnes_set_alpha,
    madnes_set_img_center,
    madnes_set_pos, madnes_set_pos_y,
    madnes_set_scale, madnes_set_texture,
    madnes_set_visible, madnes_sprite_get_frame_name, madnes_sprite_set_frame_name
} from "../framework/src/engine/madnes/madnes_object";
import {
    bigwin_particle_positions,
    boomspins_particle_positions,
    bw_particles_tmp, hide_win_text,
    set_cover_lightness, show_bigwin_text, write_win_text
} from "./jokerboom_reels";
import {
    madnes_anim_add_oncomplete_once,
    madnes_anim_loop,
    madnes_anim_play, madnes_anim_stop
} from "../framework/src/engine/madnes/madnes_anims";
import {cylinder_pos} from "./jokerboom_config";
import {madnes_tween_func, madnes_tween_stop, madnes_tween_to} from "../framework/src/engine/madnes/madnes_tween";
import {get_symbols_from_winset, set_win_pos, win_pos} from "./jokerboom_core_res_ctrl";
import {madnes_alpha_to, madnes_scale_to, madnes_shake_screen} from "../framework/src/engine/madnes/madnes_render";
import {
    ctrl_counter,
    ctrl_set_bigwin_type,
    hide_preload_win_particles,
    in_bonus,
    preload_win_particles
} from "./jokerboom_ctrl";
import {madnes_audio_play} from "../framework/src/engine/madnes/madnes_audio";
import {anim_winlines, hide_all_winlines} from "./jokerboom_winlines";
import {coins_anim_win_play, coins_anim_win_stop, coins_show} from "./jokerboom_coins";
import {madnes_money_to_coin} from "../framework/src/engine/madnes/madnes";

function madnes_fade_out(name, duration, delay, cb)
{
    if(!delay) {
        delay = 0;
    }

    setTimeout(madnes_alpha_to.bind(this, name, 0, duration, cb), delay);
}

function madnes_fade_in(name, duration, delay, cb)
{
    if (delay == 'undefined' || !delay) {
        delay = 0;
    }

    setTimeout(madnes_alpha_to.bind(this, name, 1, duration, cb), delay);
}

function madnes_anim_pulse(name, xScale, yScale, duration, delay, cb)
{

    var origScaleX = madnes_get_scale_x(name);
    var origScaleY = madnes_get_scale_y(name);

    setTimeout(madnes_scale_to.bind(this, name, xScale, yScale, duration), delay);
    setTimeout(madnes_scale_to.bind(this, name, origScaleX, origScaleY, duration), duration + delay, cb);
}

function madnes_anim_scale(name, xScale, yScale, duration, delay, callback)
{
    setTimeout(madnes_scale_to.bind(this, name, xScale, yScale, duration, callback), delay);
}

function madnes_anim_blink(name, count, duration, callback)
{
    setTimeout(function () {

        madnes_set_visible(name, !madnes_get_visible(name));

        if (count >= 0) {
            madnes_anim_blink(name, --count, duration, callback);
        } else {
            if (typeof callback === 'function') {
                callback();
            }
        }
    }, duration);
}

var anims_cover_blink_timeout;
var anims_cover_blink_switch = false;
function anims_blink_cover() {
    anims_cover_blink_timeout = setTimeout(anims_blink_cover, 250);

    anims_cover_blink_switch = !anims_cover_blink_switch;
    set_cover_lightness(anims_cover_blink_switch);
}

export function anims_blink_cover_start() {
    anims_blink_cover();
    set_cover_lightness(false);
}

export function anims_blink_cover_stop() {
    clearTimeout(anims_cover_blink_timeout);
    anims_cover_blink_timeout = null;
    set_cover_lightness(false);
}

var bigwin_bubbles_anims;
export function anims_bw_bubbles() {

    madnes_set_visible("bubbles", true);
    madnes_set_alpha("bubbles", 1);
    madnes_set_scale("bubbles", 1, 1);

    bigwin_bubbles_anims = madnes_tween_to("bubbles", { "x": 0.9, "y": 0.9 }, {
        'scale': true,
        'duration': 1100,
        'count': -1,
        'yoyo': true
    });
}

export function anims_bw_bubbles_stop() {
    bigwin_bubbles_anims && madnes_tween_stop(bigwin_bubbles_anims);
    bigwin_bubbles_anims = null;
}

var bigwin_counter_anim;
export function anims_pulse_bigwin_counter() {

    madnes_set_visible("bigwins_sparkle", true);
    madnes_set_scale("bigwins_sparkle", 1, 1);
    madnes_set_alpha("bigwins_sparkle", 1);

    bigwin_counter_anim = madnes_tween_to("bigwins_sparkle", { 'x': 0.9, 'y': 0.9 }, {
        'scale': true,
        'duration': 500,
        'count': -1,
        'yoyo': true
    });
}

export function anims_stop_bigwin_anim() {
    bigwin_counter_anim && madnes_tween_stop(bigwin_counter_anim);
    bigwin_counter_anim = null;
}

function anims_bigwin_explosion(type) {

    switch(type) {
        case "bigwins_swin":
            madnes_shake_screen(0.01, 400);
            break;
        case "bigwins_mwin":
            madnes_shake_screen(0.008, 400);
            break;
        case "bigwins_bwin":
        default:
            madnes_shake_screen(0.006, 400);
            break;
    }
}

export function anims_change_bigwin_type(type)
{
    return new Promise(function (res) {

        setTimeout(function() {

            //anims_stop_bigwin_anim();
            //anims_bw_bubbles_stop();

            madnes_tween_to("bigwins_sparkle", { 'x': 0.5, 'y': 0.5 }, {
                'scale': true,
                'duration': 240,
                'callback': function() {
                    anims_bigwin_explosion(type);

                    ctrl_set_bigwin_type(type);
                    madnes_audio_play("audio_big_win_explosion");

                    madnes_tween_to("bigwins_sparkle", { 'x': 1, 'y': 1 }, {
                        'scale': true,
                        'duration': 180,
                        'callback': function() {
                            anims_bw_bubbles();
                            res();
                        }
                    });
                }
            });

        }, 150);
    });
}

export function anims_open_bigwin_counter(to)
{
    return new Promise(function (res) {

        setTimeout(function() {
            ctrl_set_bigwin_type("bigwins_bwin");

            madnes_set_visible("bigwins", true); //madnes_set_visible("bigwins_sparkle", true);
            show_bigwin_text(true);

            madnes_set_scale("bigwins_sparkle", 0, 0);
            madnes_set_alpha("bigwins_sparkle", 0);

            madnes_alpha_to("bigwins_sparkle", 1, 340);
            madnes_scale_to("bigwins_sparkle", 1, 1, 340);

            setTimeout(function () {

                anims_bigwin_explosion("bigwins_bwin");

                madnes_audio_play("audio_big_win_explosion");

                madnes_set_visible("bubbles", true);
                madnes_set_alpha("bubbles", 0);
                madnes_set_scale("bubbles", 0, 0);

                madnes_scale_to("bubbles", 1, 1, 300);
                madnes_alpha_to("bubbles", 1, 300, res);
            }, 200);

            madnes_set_visible("bigwins_bwin", true);
            madnes_set_alpha("bigwins_bwin", 0);

            setTimeout(function () {

                madnes_alpha_to("bigwins_bwin", 1, 200);
            }, 100);

            madnes_set_scale("bigwin_text", 0, 0);
            madnes_set_alpha("bigwin_text", 0);
            madnes_set_scale("bigwin_text_2", 0, 0);
            madnes_set_alpha("bigwin_text_2", 0);

            //setTimeout(function() {
            madnes_alpha_to("bigwin_text", 1, 340);
            madnes_scale_to("bigwin_text", 1, 1, 340);
            madnes_alpha_to("bigwin_text_2", 1, 340);
            madnes_scale_to("bigwin_text_2", 1, 1, 340);
            //}, 100);

        }, to);
    });
}

export function anims_hide_bigwin_counter()
{
    anims_stop_bigwin_anim();

    madnes_fade_out("bigwin_text", 400, 0, function () {
        madnes_set_alpha("bigwin_text", 1);
        madnes_set_visible("bigwin_text", false);
    });

    madnes_fade_out("bigwin_text_2", 400, 0, function () {
        madnes_set_alpha("bigwin_text_2", 1);
        madnes_set_visible("bigwin_text_2", false);
    });

    madnes_fade_out("bigwins", 500, 0, function () {
        madnes_set_visible("bigwins", false);
        ctrl_set_bigwin_type("");
        madnes_set_alpha("bigwins", 1);
    });

    madnes_fade_out("bubbles", 500, 0, function () {
        madnes_set_visible("bubbles", false);
        madnes_set_alpha("bubbles", 1);
    });
}

export function anims_bigwin_pulse_win()
{
    return new Promise(function (res) {

        madnes_tween_to("bigwin_text", { 'x': 0.85, 'y': 0.85 }, {
            'scale': true,
            'duration': 300,
            'count': 4,
            'yoyo': true,
            'callback': res
        });

        madnes_tween_to("bigwin_text_2", { 'x': 0.85, 'y': 0.85 }, {
            'scale': true,
            'duration': 300,
            'count': 4,
            'yoyo': true
        });
    });
}

function anims_scalein_wintext(cb) {
    madnes_set_scale("win_text", 0, 0);
    madnes_set_scale("win_text_2", 0, 0);
    madnes_set_scale("win_text_bg", 0, 0);

    madnes_tween_to("win_text", {'x': 1, 'y': 1}, {
        'scale': true,
        'duration': 220,
        'callback': cb
    });

    madnes_tween_to("win_text_2", {'x': 1, 'y': 1}, {
        'scale': true,
        'duration': 220
    });

    madnes_tween_to("win_text_bg", {'x': 1, 'y': 1}, {
        'scale': true,
        'duration': 220
    });
}

/*function anims_scaleout_wintext() {
 madnes_tween_to("win_text", { 'x': 1, 'y': 1 }, {
 'scale': true,
 'duration': 200,
 'callback': function() {
 madnes_set_visible("win_text", false);
 }
 });

 madnes_tween_to("win_text_bg", { 'x': 1, 'y': 1 }, {
 'scale': true,
 'duration': 200,
 'callback': function() {
 madnes_set_visible("win_text_bg", false);
 }
 });
 }*/

//function test_win_add(a, l)
//{
//	if (!l) {
//		l = 1;
//	}
//
//
//	/*winCounterAdd = new WinCounterAdd(big_win * bet, a, 5);
//	 winCounterAdd.onUpdate = function(val) {
//	 write_win_text(val | 0);
//	 };
//
//	 winCounterAdd.onComplete = function() {
//	 coins_anim_win_stop();
//	 };
//
//	 winCounterAdd.run();
//	 */
//
//	var time = 450; //+ 450;
//
//	if (a < 5) {
//		time = 150;
//	}
//
//	setTimeout(function () {
//		//coins_show();
//		anims_scalein_wintext(coins_show);
//
//		madnes_audio_play("win_low_" + l);
//
//		ctrl_counter(time, 0, a, function (val) {
//
//			write_win_text(val | 0);
//
//		}).then(function () {
//			coins_anim_win_stop();
//		});
//
//	}, 100);
//
//	coins_anim_win_play();
//	coins_hide();
//}

function get_win_pos()
{
    if(win_pos % 4 === 0) {
        return 4;
    }

    return win_pos % 4;
}

export function anims_winline_play(win_set, hideWinDelay, fromScatter)
{
    //console.log("fromScatter " + fromScatter);

    return new Promise(function (resolve) {

        var audioName = "win_low";
        if (win_set['symbol'] && win_set['symbol'] <= 2)
        {
            audioName = "win_high";
        }

        if (typeof hideWinDelay === "undefined") {
            hideWinDelay = 0;
        }

        var symbols = get_symbols_from_winset(win_set);
        var waitFor = [];

        //show_black_screen();

        anims_set_tmp_symbols(symbols);

        if (!fromScatter && in_bonus) {
            anims_pulse_wild_reel_win();
        }

        var p = anims_play_winline_anim(symbols).then(function () {
            anims_set_origin_tmp_symbols(symbols);
        });

        waitFor.push(p);

        if (typeof win_set.line !== "undefined") {
            p = anim_winlines([win_set]);
            waitFor.push(p);
        }

        if (win_set['win']) {

            p = new Promise(function (res) {

                setTimeout(function () {

                    var time = 450;
//					if (win_set['win'] < 5) {
//						time = 150;
//					}

                    if(win_set['symbol'] <= 2) {
                        time += 300;
                    }

                    madnes_audio_play(audioName + "_" + get_win_pos());

                    set_win_pos(win_pos + 1);

                    write_win_text("0");
                    anims_scalein_wintext(coins_show);

                    coins_anim_win_play();

                    ctrl_counter(time, 0, madnes_money_to_coin(win_set['win']), function (val) {

                        write_win_text(val | 0);

                    }).then(function () {
                        coins_anim_win_stop();
                        res();
                    });

                }, 100);


                //coins_hide();
            });

            waitFor.push(p);
        };

        //preload particle
        preload_win_particles();

        p = anims_play_winline_particles(symbols, 80);
        //waitFor.push(p);

        set_cover_lightness(true);

        Promise.all(waitFor).then(function () {

            hide_preload_win_particles();

            return new Promise(function (res) {
                setTimeout(res, hideWinDelay);
            });

        }).then(function () {
            //coins_hide();

            set_cover_lightness(false).then(function() {

                anims_show_origin_symbols(symbols);

                hide_win_text();

                hide_all_winlines();
                resolve();

            });
        });
    });
}

export function anims_play_winline_particles(symbols, delayBetweenParticles)
{
    if (typeof delayBetweenParticles === "undefined") {
        delayBetweenParticles = 0;
    }

    return new Promise(function (resolve) {

        var waitFor = [];

        for (var i = 0; i < symbols.length; i++) {

            var p = new Promise(function (res) {
                var symX = symbols[i]['x'];
                var symY = symbols[i]['y'];

                //var spriteName = "reels_bufer_" + symX + "_S" + symY;
                var spriteName = "reels_bufer_" + symX + "_TMP" + symY;
                var particleName = "reels_bufer_" + symX + "_PARTICLES" + symY;
                var spriteY = madnes_get_pos_y(spriteName);

                (function (particleName, spriteY, symX, res) {

                    setTimeout(function () {

                        madnes_set_pos_y(particleName, spriteY);
                        madnes_set_visible(particleName, true);

                        madnes_anim_add_oncomplete_once(particleName, function () {
                            madnes_set_pos_y(particleName, -9999);
                            madnes_set_visible(particleName, false);
                            res();
                        });

                        madnes_anim_play(particleName, "anim", 24);

                    }, (symX + 1) * delayBetweenParticles);

                    //console.log(symX * delayBetweenParticles);

                }(particleName, spriteY, symX, res));
            });

            waitFor.push(p);
        }

        Promise.all(waitFor).then(resolve);

    });
}

export function hide_all_win_particles()
{
    for (var i = 0; i < cylinder_pos.length; i++)
    {
        for (var j = 0; j <= 2; j++)
        {
            var particleName = "reels_bufer_" + i + "_PARTICLES" + j;
            madnes_set_pos_y(particleName, -9999);
            madnes_set_visible(particleName, false);
        }
    }
}

export function anims_play_winline_anim(symbols)
{
    return new Promise(function (res) {
        for (var i = 0; i < symbols.length; i++) {
            var symX = symbols[i]['x'];
            var symY = symbols[i]['y'];

            //var symbName = madnes_sprite_get_frame_name(symbols[i]['spriteName']).replace("_blur", "");
            var spriteTmpName = "reels_bufer_" + symX + "_TMP" + symY;

            /*madnes_anim_add(spriteTmpName, "anim", icons[symbName]["anim"]);
             madnes_anim_add_oncomplete(spriteTmpName, function() {
             res();
             });

             madnes_anim_play(spriteTmpName, "anim", 30);
             */

            (function (spriteTmpName) {

                /*madnes_tween_to(spriteTmpName, { 'x': 1.4, 'y': 1.4 }, {
                    'scale': true,
                    'duration': 400,
                    'callback': function() {

                        madnes_tween_to(spriteTmpName, { 'x': 1, 'y': 1 }, {
                            'scale': true,
                            'duration': 200,
                            'callback': function() {

                                madnes_tween_to(spriteTmpName, { 'x': 1.12, 'y': 1.12 }, {
                                    'scale': true,
                                    'duration': 200,
                                    'callback': function() {

                                        madnes_tween_to(spriteTmpName, { 'x': 1, 'y': 1 }, {
                                            'scale': true,
                                            'duration': 400,
                                            'callback': res
                                        });
                                    }
                                });
                            }
                        });
                    }
                });*/

                madnes_tween_to(spriteTmpName, { 'x': 1.42, 'y': 1.42 }, {
                    'scale': true,
                    'duration': 380,
                    'easing': madnes_tween_func("cubic_out"),
                    'callback': function() {
                        madnes_tween_to(spriteTmpName, { 'x': 1.06, 'y': 1.06 }, {
                            'scale': true,
                            'duration': 200,
                            'ease': madnes_tween_func("cubic_in"),
                            'callback': function() {
                                madnes_tween_to(spriteTmpName, { 'x': 1.2, 'y': 1.2 }, {
                                    'scale': true,
                                    'duration': 300,
                                    'easing': madnes_tween_func("cubic_out"),
                                    'callback': function() {
                                        madnes_tween_to(spriteTmpName, { 'x': 1, 'y': 1 }, {
                                            'scale': true,
                                            'duration': 200,
                                            'callback': res,
                                            'ease': madnes_tween_func("cubic_in"),
                                        });
                                    }
                                });
                            }
                        });
                    }
                });

            }(spriteTmpName));
        }
    });
}

export function anims_set_tmp_symbols(symbols)
{
    //return new Promise(function(resolve) {
    for (var i = 0; i < symbols.length; i++) {

        var symX = symbols[i]['x'];
        var symY = symbols[i]['y'];

        var x = madnes_get_pos_x(symbols[i]['spriteName']);
        var y = madnes_get_pos_y(symbols[i]['spriteName']);

        var symbName = madnes_sprite_get_frame_name(symbols[i]['spriteName'])/*.replace("_blur", "")*/;

        //console.log(symbName);

        var tmpSpriteName = "reels_bufer_" + symX + "_TMP" + symY;
        var spriteName = "reels_bufer_" + symX + "_S" + symY;

        //madnes_set_texture(tmpSpriteName, symbName + "_json");
        //madnes_sprite_set_frame_name(tmpSpriteName, symbName + "_00000");

        //madnes_set_texture(tmpSpriteName, "symbols_big_json");
        //madnes_sprite_set_frame_name(tmpSpriteName, symbName + "_00011");

        //madnes_set_texture(tmpSpriteName, symbName + "_big");

        madnes_set_texture(tmpSpriteName, symbName + "_sprite_json");

        madnes_set_pos(tmpSpriteName, x /*+ 4*/, y);
        madnes_set_visible(tmpSpriteName, true);
        madnes_set_visible(spriteName, false);

        //madnes_set_scale(tmpSpriteName, 0.62, 0.62);
    }

    //resolve();
    //});
}

export function anims_show_origin_symbols(symbols)
{
    for (var i = 0; i < symbols.length; i++) {
        var symX = symbols[i]['x'];
        var symY = symbols[i]['y'];

        var tmpSpriteName = "reels_bufer_" + symX + "_TMP" + symY;
        var spriteName = "reels_bufer_" + symX + "_S" + symY;

        //var symbolName = madnes_sprite_get_frame_name(symbols[i]['spriteName'])/*.replace("_blur", "")*/;
        //console.log(symbolName);

        madnes_set_pos_y(tmpSpriteName, -9999);
        madnes_set_visible(tmpSpriteName, false);
        //madnes_set_texture(tmpSpriteName, symbolName + "_sprite_json");

        madnes_set_visible(spriteName, true);
    }
}

export function anims_set_origin_tmp_symbols(symbols)
{
    for (var i = 0; i < symbols.length; i++) {
        var symX = symbols[i]['x'];
        var symY = symbols[i]['y'];

        var tmpSpriteName = "reels_bufer_" + symX + "_TMP" + symY;
        //var spriteName = "reels_bufer_" + symX + "_S" + symY;

        var symbolName = madnes_sprite_get_frame_name(symbols[i]['spriteName'])/*.replace("_blur", "")*/;
        madnes_set_texture(tmpSpriteName, symbolName + "_sprite_json");
    }
}

var boomspins_stopped = true;
export function anims_scalein_boom_spins(num) {
    return new Promise(function (res) {

        madnes_sprite_set_frame_name("bs_num", num);

        madnes_set_visible("group_boom_spins", true);
        madnes_set_scale("group_boom_spins", 0, 0);

        madnes_tween_to("group_boom_spins", { 'x': 1, 'y': 1 }, {
            'scale': true,
            'duration': 300,
            'callback': res
        });
    });
}

export function anims_scaleout_boom_spins() {
    return new Promise(function (res) {

        madnes_tween_to("group_boom_spins", { 'x': 0, 'y': 0 }, {
            'scale': true,
            'duration': 300,
            'callback': function() {
                madnes_set_visible("group_boom_spins", false);
                res();
            }
        });
    });
}

var boomspins_anim;
export function anims_pulse_boom_spins(duration)
{
    return new Promise(function (res) {

        boomspins_anim = madnes_tween_to("group_boom_spins", { 'x': 0.85, 'y': 0.85 }, {
            'scale': true,
            'duration': 500,
            'count': -1,
            'yoyo': true
        });

        duration && setTimeout(function () {

            anims_stop_pulse_boom_spins();
            res();
        }, duration);
    });
}

function anims_stop_pulse_boom_spins()
{
    boomspins_anim && madnes_tween_stop(boomspins_anim);
    boomspins_anim = null;
}

export function anims_pulse_wild_reel() {
    return new Promise(function (res) {

        madnes_set_visible("wild_reel", true);
        madnes_set_visible("wild_reel_bg", true);

        madnes_set_scale("wild_reel", 0.8, 0.8);
        madnes_set_scale("wild_reel_bg", 1, 1);

        madnes_audio_play("bonus_joker");

        madnes_tween_to("wild_reel", { 'x': 1, 'y': 1 }, {
            'scale': 1,
            'duration': 180,
            'yoyo': true,
            'callback': function() {
                madnes_set_scale("wild_reel", 0.8, 0.8);
                res();
            }
        });

        madnes_tween_to("wild_reel_bg", { 'x': 1.2, 'y': 1.2 }, {
            'scale': true,
            'duration': 180,
            'yoyo': true,
            'callback': function() {
                madnes_set_scale("wild_reel_bg", 1, 1);
            }
        });
    });
}

export function anims_pulse_wild_reel_win() {
    return new Promise(function (res) {

        madnes_set_scale("wild_reel_bg", 1, 1);

        madnes_tween_to("wild_reel_bg", { 'x': 1.4, 'y': 1.4 }, {
            'scale': true,
            'duration': 340,
            //'easing': madnes_tween_func("cubic_out"),
            'callback': function() {
                madnes_tween_to("wild_reel_bg", { 'x': 1.06, 'y': 1.06 }, {
                    'scale': true,
                    'duration': 200,
                    //'ease': madnes_tween_func("cubic_in"),
                    'callback': function() {
                        madnes_tween_to("wild_reel_bg", { 'x': 1.14, 'y': 1.14 }, {
                            'scale': true,
                            'duration': 300,
                            //'easing': madnes_tween_func("cubic_out"),
                            'callback': function() {
                                madnes_tween_to("wild_reel_bg", { 'x': 1, 'y': 1 }, {
                                    'scale': true,
                                    'duration': 200,
                                    'callback': res,
                                    //'ease': madnes_tween_func("cubic_in"),
                                });
                            }
                        });
                    }
                });
            }
        });

        /*madnes_tween_to("wild_reel_bg", { 'x': 1.2, 'y': 1.2 }, {
            'scale': true,
            'duration': 300,
            'callback': function() {

                madnes_tween_to("wild_reel_bg", { 'x': 1, 'y': 1 }, {
                    'scale': true,
                    'duration': 300,
                    'callback': function() {

                        madnes_tween_to("wild_reel_bg", { 'x': 1.1, 'y': 1.1 }, {
                            'scale': true,
                            'duration': 300,
                            'callback': function() {

                                madnes_tween_to("wild_reel_bg", { 'x': 1, 'y': 1 }, {
                                    'scale': true,
                                    'duration': 300,
                                    'callback': res
                                });
                            }
                        });
                    }
                });
            }
        });*/

        madnes_set_scale("wild_reel", 0.8, 0.8);

        madnes_tween_to("wild_reel", { 'x': 1, 'y': 1 }, {
            'scale': true,
            'duration': 380,
            'easing': madnes_tween_func("cubic_out"),
            'callback': function() {
                madnes_tween_to("wild_reel", { 'x': 0.85, 'y': 0.85 }, {
                    'scale': true,
                    'duration': 200,
                    'ease': madnes_tween_func("cubic_in"),
                    'callback': function() {
                        madnes_tween_to("wild_reel", { 'x': 0.95, 'y': 0.95 }, {
                            'scale': true,
                            'duration': 300,
                            'easing': madnes_tween_func("cubic_out"),
                            'callback': function() {
                                madnes_tween_to("wild_reel", { 'x': 0.8, 'y': 0.8 }, {
                                    'scale': true,
                                    'duration': 200,
                                    'callback': res,
                                    'ease': madnes_tween_func("cubic_in"),
                                });
                            }
                        });
                    }
                });
            }
        });

        /*
        madnes_set_scale("wild_reel", 0.8, 0.8);
        madnes_tween_to("wild_reel", { 'x': 1, 'y': 1 }, {
            'scale': true,
            'duration': 300,
            'callback': function() {

                madnes_tween_to("wild_reel", { 'x': 0.85, 'y': 0.85 }, {
                    'scale': true,
                    'duration': 300,
                    'callback': function() {

                        madnes_tween_to("wild_reel", { 'x': 0.95, 'y': 0.95 }, {
                            'scale': true,
                            'duration': 300,
                            'callback': function() {

                                madnes_tween_to("wild_reel", { 'x': 0.8, 'y': 0.8 }, {
                                    'scale': true,
                                    'duration': 300
                                });
                            }
                        });
                    }
                });
            }
        });*/
    });
}


export function anims_fadeout_logo() {
    return new Promise(function (res) {

        madnes_fade_out("game_logo", 120, 0, res);

        /*TweenMax.to(madnes_objects["game_logo"], {
         alpha: 0,

         });*/
    });
}

export function anims_fadeout_clock() {
    return new Promise(function (res) {
        madnes_fade_out("clock", 120, 0, res);
    });
}

export function anims_fadein_clock() {
    return new Promise(function (res) {
        madnes_set_visible("clock", true);
        madnes_set_alpha("clock", 0);
        madnes_fade_in("clock", 120, 0, function() {
            res();
        });
    });
}

export function anims_fadein_logo() {
    return new Promise(function (res) {
        madnes_fade_in("game_logo", 120, 0, res);
    });
}

export function hide_all_bw_particles() {
    for (var i in bw_particles_tmp) {
        madnes_set_pos("bw_particles_" + i, -9999, -9999);
        madnes_set_visible("bw_particles_" + i, false);
    }
}

export function play_boomspins_particles() {
    var j = 0;
    for (var i in boomspins_particle_positions) {

        (function (i, j) {
            setTimeout(function () {

                var x = boomspins_particle_positions[i]['x'];
                var y = boomspins_particle_positions[i]['y'];
                var scale = boomspins_particle_positions[i]['scale'];

                madnes_set_img_center("bw_particles_" + i, 0.5, 0.5);
                madnes_set_scale("bw_particles_" + i, scale, scale);
                madnes_set_pos("bw_particles_" + i, x, y);
                madnes_set_visible("bw_particles_" + i, true);

                madnes_anim_add_oncomplete_once("bw_particles_" + i, function () {
                    madnes_set_visible("bw_particles_" + i, false);
                    madnes_set_pos("bw_particles_" + i, -9999, -9999);
                });

                madnes_anim_play("bw_particles_" + i, "anim", 24);

            }, j * 80);
        }(i, j));
        j++;
    }
}

/*function set_bigwin_particles_positions()
 {
 for(var i in bigwin_particle_positions) {
 var x = bigwin_particle_positions[i].x;
 var y = bigwin_particle_positions[i].y;

 madnes_set_pos("bw_particles_" + i, x, y);
 madnes_set_visible("bw_particles_" + i, false);
 }
 }*/

export function loop_bigwin_particles() {
    var j = 0;
    for (var i in bigwin_particle_positions) {

        (function (i, j) {

            setTimeout(function () {

                var x = bigwin_particle_positions[i]['x'];
                var y = bigwin_particle_positions[i]['y'];
                var scale = bigwin_particle_positions[i]['scale'];

                madnes_set_img_center("bw_particles_" + i, 0.5, 0.5);
                madnes_set_scale("bw_particles_" + i, scale, scale);
                madnes_set_pos("bw_particles_" + i, x, y);

                madnes_set_visible("bw_particles_" + i, true);
                madnes_anim_loop("bw_particles_" + i, "anim", 24);
            }, j * 60);

        }(i, j));
        j++;
    }
}

export function stop_bigwin_particles() {
    for (var i in bigwin_particle_positions) {

        (function (i) {

            setTimeout(function () {
                madnes_anim_stop("bw_particles_" + i);
                madnes_set_visible("bw_particles_" + i, false);
                madnes_set_pos("bw_particles_" + i, -9999, -9999);
            }, i * 80);

        }(i));
    }
}

function hide_all_buffered_tmp_symbols() {
    for (var i = 0; i < cylinder_pos.length; i++) {
        for (var j = 0; j <= 2; j++) {
            madnes_set_visible("reels_bufer_" + i + "_TMP" + j, false);
            madnes_set_pos_y("reels_bufer_" + i + "_TMP" + j, -9999);
        }
    }
}

export var black_screen_opened = false;

export function open_black_screen() {
    if (black_screen_opened) {
        return;
    }

    black_screen_opened = true;
    show_black_screen();

}

export function close_black_screen() {
    if (!black_screen_opened) {
        return;
    }

    black_screen_opened = false;
    hide_black_screen();
}

function show_black_screen() {
    madnes_set_visible("black_screen_graphics", true);
    madnes_set_pos("black_screen_graphics", 0, 0);
    madnes_set_alpha("black_screen_graphics", 0.65);
    //madnes_set_cstm_val("black_screen_graphics", false); //hided = false
}

export function hide_black_screen() {
    madnes_set_pos("black_screen_graphics", -9999, -9999);
    madnes_set_visible("black_screen_graphics", false);
    //madnes_set_cstm_val("black_screen_graphics", true); //hided = true
}

export function fadeout_black_screen() {
    return new Promise(function (res) {
        madnes_alpha_to("black_screen_graphics", 0, 180, function () {
            hide_black_screen();
            res();
        });
    });
}

export function fadein_bonus_bg() {
    return new Promise(function(res) {

        madnes_set_pos("background2", 0, 0);
        madnes_set_visible("background2", true);
        madnes_set_alpha("background2", 0);

        madnes_tween_to("background2", { 'alpha': 1 }, {
            'duration': 200,
            'callback': function() {
                madnes_set_visible("background", false);
                madnes_set_pos("background", -9999, -9999);

                res();
            }
        });
    });
}

export function fadeout_bonus_bg() {
    return new Promise(function(res) {

        madnes_set_visible("background", true);
        madnes_set_pos("background", 0, 0);
        madnes_set_alpha("background2", 1);

        madnes_tween_to("background2", { 'alpha': 0 }, {
            'duration': 200,
            'callback': function() {

                madnes_set_pos("background2", -9999, -9999);
                madnes_set_visible("background2", false);
                res();
            }
        });
    });
}

var symbols_pulse_anim = {};
var symbols_pulse_stopped = false;

export function anims_pulse_symbols() {

    symbols_pulse_stopped = false;

    for(var i = 0; i < cylinder_pos.length; i++) {

        for(var j = 0; j <= 2; j++) {

            var spriteName = "reels_bufer_" + i + "_S" + j;
            var tmpSpriteName = "reels_bufer_" + i + "_TMP" + j;

            (function(spriteName, tmpSpriteName) {

                if(madnes_get_visible(spriteName)) {
                    anims_symbol_scale_in(spriteName);
                }

                if(madnes_get_visible(tmpSpriteName)) {
                    anims_symbol_scale_in(tmpSpriteName);
                }


            } (spriteName, tmpSpriteName));
        }
    }
}

function anims_symbol_scale_in(spriteName) {

    symbols_pulse_anim[spriteName] = madnes_tween_to(spriteName, { 'x': 1.025, 'y': 1.025 }, {
        'scale': true,
        'duration': 400,
        'callback': function() {
            anim_symbols_scale_out(spriteName);
        }
    });
}

function anim_symbols_scale_out(spriteName) {

    if(!symbols_pulse_anim[spriteName]) {
        return;
    }

    symbols_pulse_anim[spriteName] = madnes_tween_to(spriteName, { 'x': 1, 'y': 1 }, {
        'scale': true,
        'duration': 400,
        'callback': function() {
            if(symbols_pulse_stopped) {
                symbols_pulse_anim[spriteName] = null;
                //delete symbols_pulse_anim[spriteName];
            } else {
                anims_symbol_scale_in(spriteName);
            }
        }
    });
}

export function anims_pulse_symbols_stop() {
    symbols_pulse_stopped = true;
}